import Alert from "react-bootstrap/Alert";

const About = (props) => {
  const { bio } = props;

  const displayProfileBio = () => {
    if (bio !== null && bio !== "") {
      var profileBioFormatted = bio.replace(/[?<>{}]/g, "•");

      return (
        <div className="card">
          <div className="card-body">
            <span className="p-wrap">{profileBioFormatted}</span>
          </div>
        </div>
      );
    } else {
      return (
        <Alert key={"info"} variant={"info"}>
          Profile bio not available!
        </Alert>
      );
    }
  };

  return displayProfileBio();
};

export default About;
